import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { PushboxLeftNavigationComponent } from 'src/app/care/pushbox/pushbox-left-navigation/pushbox-left-navigation.component';
import { PushboxTaskListComponent } from 'src/app/care/pushbox/pushbox-task-list/pushbox-task-list.component';
import { PushboxComponent } from 'src/app/care/pushbox/pushbox/pushbox.component';
import { PushboxService } from 'src/app/care/pushbox/services/pushbox.service';

downgradedAngularModule
  .directive('angularPushbox', downgradeComponent({ component: PushboxComponent }))
  .directive('angularPushboxTaskList', downgradeComponent({ component: PushboxTaskListComponent }))
  .directive('angularPushboxLeftNavigation', downgradeComponent({ component: PushboxLeftNavigationComponent }))
  .factory('AngularPushboxService', downgradeInjectable(PushboxService));
